'use client';

export { default } from './InputAdornment';
export { default as inputAdornmentClasses } from './inputAdornmentClasses';
export * from './inputAdornmentClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/InputAdornment/index.js
// module id = 858
// module chunks = 22